import consoleLogger from '../../logger/consoleLogger';
import { CurrentEntryPoint } from '../../constants/CurrentEntryPoint';
import { GtmSender } from '../../marketing/GtmSender';
import { gameEvents } from '../../constants/gameEvents';
import { isTestMode } from './utilityFunctions';

const logger = consoleLogger.getPrefixedCopy('CLIENT_TO_JS_OLD');
window.app.setPayerFlag = cmdSetPayerFlag;

function cmdSetPayerFlag() {
    window.app.user.hasPayment = true;
}


export function cmdSetPayerInfo(nickname: string, donateint: number) {
    window.app.user.gameNickname = nickname;
    window.app.user.donate = donateint;
    window.app.user.hasPayment = !!donateint;

    if (typeof window.app.fb_purchase_info === 'function') {
        window.app.fb_purchase_info(nickname, donateint);
    }
}


export function cmdPaymentWindowIconClick() {
    const allowedPixelEntryPoints = [CurrentEntryPoint.FB2];

    logger.info('app.paymentWindowIconClick');
    try {
        if (
            !isTestMode() &&
            (allowedPixelEntryPoints.indexOf(window.app.config.current_entry_point) !== -1)
        ) {
            logger.info('fb_pixel paymentWindowIconClick');
        }
    } catch (error) {
        window.Sentry.captureException(error);
    }
}


export function cmdSendTutorCompleted() {
    const allowedPixelEntryPoints = [CurrentEntryPoint.SITE2];
    if (!isTestMode() && typeof window.fbq === 'function' &&
        (allowedPixelEntryPoints.indexOf(window.app.config.current_entry_point) !== -1)) {
        GtmSender.fireMarketing(gameEvents.TUTOR_FINISH);
    }
}
